/* 
	file: 			detect-device.js 
	title: 			Detect device mobile/desktop and add class to body
	description: 	In page content two bottons:
						<p class="primary href_switch_mobile"><a href="[{DOWNLOAD-SINGLE(BS-MARKET)}]" class="button blue large"><span>{FreeInstall}</span></a></p>
						<p class="primary href_switch_desktop"><a href="[{DOWNLOAD-SINGLE(BS)}]" class="button blue large"><span>{FreeInstall}</span></a></p>
	author: 		Pavel Prokes, Avast Software
	use: 			Use with this css:
						.detect-desktop .href_switch_mobile {
						    display: none;
						}
						.detect-mobile .href_switch_desktop {
						  display: none;
						}
*/

var detect = avm.require('avast.detect');
var detecting = detect(); //Browser and OS detection, return following object

if (detecting.os.isAndroid) {
	$('body').addClass('detect-mobile');
} else {
	$('body').addClass('detect-desktop');
}